import React, { lazy } from "react";
import Spinner from "../../../mui/Spinner.jsx";
import ShowContainer from "../../../mui/ShowContainer.jsx";
import { useAppSelector } from "../../../../store/index.ts";
import { ENUM_ELEMENT_ID } from "../../../common/enums.js";
import useStreamStatus from "../../../../hooks/site/useStreamStatus.js";
import useBlockHeight from "../../../../hooks/site/useBlockHeight.js";
import BroadcasterWindow from "../broadcaster_window/BroadcasterWindow.jsx";
import ErrorBoundary from "../../../mui/error_boundary/ErrorBoundary.jsx";
import useDetectKeyboardOpen from "use-detect-keyboard-open";
import "./chat_content_open_keyboard/chat-content-open-keyboard.scss";
import LoaderContainer from "../../../mui/LoaderContainer.jsx";
import ErrorSuspense from "../../../mui/ErrorSuspense.jsx";

const ChatBroadcasterChatController = lazy(() => import("./ChatBroadcasterChatController.jsx"));

export default function ChatTabStreamContent() {
  const isFullscreenChat = useAppSelector((state) => state.common.controls.isFullscreenChat);
  const isFullScreen = useAppSelector((state) => state.common.flags.foolScreen);
  const isMobile = useAppSelector((state) => state.deviceSize.isMobile);
  const isMobileSize = useAppSelector((state) => state.deviceSize.isMobileSize);

  const { isLoading, status } = useStreamStatus();
  const { chatContentHeight } = useBlockHeight();
  const isKeyboardOpen = useDetectKeyboardOpen();

  const noChatClass = isFullscreenChat ? "" : "no-chat";
  const fulScreenClass = isFullScreen ? "ful-screen" : "";
  const isHide = isLoading ? "hide" : "";
  const keyboardClass = isKeyboardOpen && isMobileSize ? "open-keyboard" : "";
  const classContent = `${noChatClass} ${fulScreenClass} ${isHide} ${keyboardClass}`;

  const chatContentStyle = { height: isMobile ? undefined : chatContentHeight };

  console.log("isLoading", isLoading, status);

  return (
    <>
      <ShowContainer condition={isLoading}>
        <div className="chat__content__loader" style={chatContentStyle}>
          <Spinner />
        </div>
      </ShowContainer>

      <div
        id={ENUM_ELEMENT_ID.chatContent}
        style={chatContentStyle}
        className={`chat__content ${classContent}`}
      >
        <ErrorBoundary>
          <BroadcasterWindow />
        </ErrorBoundary>
        <ErrorSuspense fallback={<LoaderContainer center loader />}>
          <ChatBroadcasterChatController />
        </ErrorSuspense>
      </div>
    </>
  );
}
